import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Panel, Modal } from 'react-bootstrap';
import { CANCEL_REASONS } from '../../../config/constants';
import { removeShopsFromOrder } from '../orderDetails.actions';
import { cancelOrderByApi, forceUpdateOrder } from '../../orders/orders.actions';
import translator from '../../../components/localization/translator';
import FooterButtons from '../../../components/common/elements/FooterButtons';
import './OrderDetails.css';

class SelectShopsForMergeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedShops: this.props.shops
        };
        this.renderOrderCard = this.renderOrderCard.bind(this);
        this.saveHandler = this.saveHandler.bind(this);
        this.hide = this.hide.bind(this)
    }

    renderOrderCard(order) {
        return (
            <Panel fill='true' className={`padding-vertical`} style={{ width: '50%' }} key={order.orderId}>
                <Panel.Heading  >
                    <div className={order.isParent ? ' green-color' : ''}>
                        <input type={'checkbox'}
                            className={'to-right'}
                            onChange={e => {
                                if (e.target.checked) {
                                    const newSelectedShops = this.state.selectedShops.concat(order.shops.filter(item => {
                                        return this.state.selectedShops && this.state.selectedShops.length && !!this.state.selectedShops.find(shop => item._id !== shop._id)
                                    }
                                    ));
                                    this.setState({ selectedShops: newSelectedShops })
                                } else {
                                    this.setState({ selectedShops: this.state.selectedShops.filter(shop => !order.shops.find(item => item._id === shop._id)) })
                                }
                            }}
                            checked={order.shops.every(item => this.state.selectedShops.find(el => el._id === item._id))}
                        />
                        {order.orderId}
                    </div>
                </Panel.Heading>
                <Panel.Body>
                    {order.shops.map((shop, i) => {
                        const address = shop.restaurantInfo
                            && shop.restaurantInfo.restaurantInformation
                            && shop.restaurantInfo.restaurantInformation.location
                            && shop.restaurantInfo.restaurantInformation.location.address;
                        return (
                            <div key={i}>
                                <input type={'checkbox'}
                                    className={'to-right'}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            this.setState({ selectedShops: this.state.selectedShops.concat([shop]) })
                                        } else {
                                            this.setState({ selectedShops: this.state.selectedShops.filter(item => item._id !== shop._id) })
                                        }
                                    }}
                                    checked={!!this.state.selectedShops.find(item => item._id === shop._id)}
                                />
                                {shop.shopName}
                                <div className={'address-label'}> {address}</div>
                            </div>
                        )
                    })}
                </Panel.Body>
            </Panel>
        )
    };

    saveHandler() {
        let comments = '';
        const cancelOrders = this.props.data.map(order => {
            return order.shops.every(shop =>
                !!this.state.selectedShops.find(item => item._id == shop._id))
                ? {orderId: order.orderId, comments: order.comments}
                : null;
        }).filter(order => !!order && !!order.orderId && order.orderId !== this.props.mainOrderId);
        if (cancelOrders && cancelOrders.length) {
            let cancelData = {
                mergedParentId: this.props.mainOrderId,
                cancelReason: {
                    reason: CANCEL_REASONS.MERGED.id,
                    comment: '',
                }
            };
            cancelOrders.forEach(order => {
                comments += order.comments
                this.props.cancelOrderByApi(order.orderId, cancelData);
            });
        }
        const deleteShops = this.props.data.map(order => {
            const tempShops = order.shops.filter(shop => !!this.state.selectedShops.find(item => item._id == shop._id));
            if (tempShops && tempShops.length) {
                return {
                    orderId: order.orderId,
                    shops: tempShops.map(shop => shop._id)
                }
            } else {
                return null;
            }
        }).filter(order => !!order && order.orderId !== this.props.mainOrderId && !cancelOrders.find(e => e.orderId == order.orderId));
        if (deleteShops && deleteShops.length) {
            deleteShops.forEach(order => {
                this.props.removeShopsFromOrder(order, (orderData) => {
                    if (orderData) {
                        this.props.forceUpdateOrder(orderData);
                    }
                });
            });
        }
        this.props.save(this.state.selectedShops,comments);
    }

    hide() {
        this.props.hide();
    }

    renderFooter() {
        return (
            <Modal.Footer>
                <FooterButtons
                    cancelButton={translator.translate("_cancel_")}
                    saveButton={translator.translate("_save_")}
                    save={this.saveHandler}
                    cancel={this.hide} />
            </Modal.Footer>
        );
    }

    render() {
        return (
            <Modal
                dialogClassName='small-modal'
                show={this.props.show}
                onHide={this.hide}
                onKeyPress={this.handleKeyPress}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {translator.translate('_select_shops_')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="scrollable modal-possition flex-wrap">
                    {this.props.data.map((item) => this.renderOrderCard(item))}
                </Modal.Body>
                {this.renderFooter()}
            </Modal>
        );
    }
}

export default connect(
    null, {
        cancelOrderByApi,
        removeShopsFromOrder,
        forceUpdateOrder
    }
)(SelectShopsForMergeModal);
